<div class="wrapper" matRipple [matRippleColor]="'#8f8f8f40'"  [matTooltip]="title" [matTooltipDisabled]="!hideContent" tooltip="">
  <fa-icon *ngIf="icon" [icon]="icon" size="lg" [ngClass]="{'disabled': this.disabled}" ></fa-icon>
  <ng-content [ngClass]="{'disabled': this.disabled}"></ng-content>
  <div *ngIf="!hideContent" class="title" tooltip="" [ngClass]="{'disabled': this.disabled}">{{title}}</div>
</div>
